import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import { equals, isEmpty, isPostalCode } from 'validator';
import { StyledTooltipWrapper } from '../../ProductTagWizard/Elements/Tooltip/StyledTooltip';
import Tooltip from '../../ProductTagWizard/Elements/Tooltip';
// import { FieldLabel } from "./StyledField";

// OPTIMIZE: create FORM around fields to allow enter trigger
// OPTIMIZE: liveValidation flag to allow validation onBlur/as we go
// OPTIMIZE: custom messages for different validations (user validate.js)

class Field extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayError: false,
            hasError: false,
            hasSuccess: false,
            isFocused: false,
            isFilled: !isEmpty(String(this.props.value)),
            showTooltip: false,
            showPercentageSign: false,
            errorHeight: 0,
        };
    }
    // OPTIMIZE: use getSnapshotBeforeUpdate
    componentDidUpdate(prevProps, prevState) {
        this.lastValue = this.props.value;

        // console.log(this.input, propsN.checked, prevPropsN.checked);
        // check any changes to the props/state
        // if ((JSON.stringify(propsN) !== JSON.stringify(prevPropsN) || JSON.stringify(this.state) !== JSON.stringify(prevState))) {
        if (
            prevProps.value !== this.props.value ||
            (this.props.value == '' && prevProps.value !== this.props.value) ||
            this.props.min !== prevProps.min ||
            this.props.max !== prevProps.max
        ) {
            this.setState(this.getClassesState());
        }

        if (
            prevState.displayError !== this.state.displayError ||
            prevProps.forceDisplayError !== this.props.forceDisplayError ||
            prevProps.alertMessage !== this.props.alertMessage ||
            ((this.props.forceDisplayError || prevState.displayError) && this.state.errorHeight === 0)
        ) {
            this.calculateAlertArea();
        }
    }
    componentDidMount() {
        const { autoFocus = false, autoHighlight = false, forceDisplayError } = this.props;

        if (autoFocus) {
            this.input.focus();
        }
        if (autoHighlight) {
            this.input.select();
        }
        if (forceDisplayError) {
            this.calculateAlertArea();
        }
    }
    calculateAlertArea() {
        const { forceDisplayError } = this.props;
        const { displayError } = this.state;

        if (displayError || forceDisplayError) {
            let alertEl = this.field.querySelector('.field__alert');
            if (alertEl) {
                setTimeout(() => {
                    let alertElHeight = $(alertEl).outerHeight(true);

                    this.setState({
                        errorHeight: Number(alertElHeight)
                    });
                }, 10);
            }
        }
    }
    getErrorClassesState() {
        const valid = this.validate();
        const isFilled = this.validateEmpty();

        return {
            hasSuccess: valid && isFilled ? true : false,
            hasError: !valid && isFilled ? true : false,
            displayError: valid ? false : this.state.displayError,
        };
    }
    getClassesState() {
        const { required } = this.props;
        let newState = {
            isFilled: this.validateEmpty(),
        };

        if (required) {
            newState = {
                ...newState,
                ...this.getErrorClassesState(),
            };
        }
        return newState;
    }
    // `generateProps` handles what are the essential props to be passed down to the extended component
    generateProps() {
        const {
            name,
            value,
            readOnly,
            disabled,
            placeholder,
            autoComplete,
            required,
            isLoading,
        } = this.props;
        return {
            name: name,
            value: value,
            readOnly: readOnly,
            disabled: disabled || isLoading,
            placeholder: placeholder,
            autoComplete: autoComplete,
            required: required,
            onKeyDown: (e) => this.onKeyDown(e),
            onKeyPress: (e) => this.onKeyPress(e),
            onChange: (e) => this.onChange(e),
            onFocus: (e) => this.onFocus(e),
            onBlur: (e) => this.onBlur(e),
        };
    }
    // `handleClasses` handles all the default classes that can be used to changed the fields style
    handleClasses() {
        const {
            alone,
            className,
            checked,
            inline,
            big,
            isDisabled,
            isLoading,
            showPercentageSign,
            forceDisplayError,
        } = this.props;
        const { isFocused, isFilled, hasError, hasSuccess } = this.state;
        let classes = 'field';

        if (alone) {
            classes = classes.concat(' field--alone');
        }
        if (inline) {
            classes = classes.concat(' field--inline');
        }
        if (checked) {
            classes = classes.concat(' field--checked');
        }
        if (big) {
            classes = classes.concat(' field--big');
        }
        if (hasError || forceDisplayError) {
            classes = classes.concat(' field--alert');
        }
        if (hasSuccess) {
            classes = classes.concat(' field--success');
        }
        if (isFocused) {
            classes = classes.concat(' field--focus');
        }
        if (!isEmpty(String(this.props.value))) {
            classes = classes.concat(' field--filled');
        }
        if (isDisabled || isLoading) {
            classes = classes.concat(' field--disabled');
        }
        if (isLoading) {
            classes = classes.concat(' field--loading');
        }
        if (className) {
            classes = classes.concat(` ${className}`);
        }
        if (showPercentageSign) {
            classes = classes.concat(` field--percentage-sign`);
        }

        return classes;
    }
    // `handleStyle` handles all the default style
    handleStyle() {
        const { forceDisplayError } = this.props;
        const { hasError, errorHeight } = this.state;

        let style = {};

        if (hasError || forceDisplayError) {
            if (errorHeight > 20) {
                style.marginBottom = errorHeight;
            }
        }

        return style;
    }
    // validations
    // `validate` will always be triggered on the componentDidUpdate so that we can check if the latest value is valid
    validateExtraConditions() {
        const { value, identical, validate } = this.props;
        let extraConditions = true;

        // identical prop
        if (identical) {
            extraConditions =
                extraConditions && equals(String(value), String(identical));
        }

        if (validate === 'postcode') {
            extraConditions =
                extraConditions && isPostalCode(String(value), 'AU');
        }

        return extraConditions;
    }
    validateEmpty() {
        const { value, required } = this.props;

        if (required) {
            return !isEmpty(String(value));
        }

        return true;
    }
    validate() {
        const extraConditions = this.validateExtraConditions();

        return this.validateEmpty() && extraConditions;
    }
    // `format` will always be triggered BEFORE any value is updated, so that it can be changed to fit any conditions
    format(value) {
        return value;
    }
    setInputSelection(start, end) {
        if (start != null) {
            this.input.selectionStart = start || 0;
        }
        if (end != null) {
            this.input.selectionEnd = end || 0;
        }
    }
    // events
    onKeyDown(e) {
        // saves the last character as 'false' for cases like input type=number, which doesn't trigger the onChange
        this.lastInput = false;
    }
    onKeyPress(e) {
        // saves the last character typed
        const charCode = e.which || e.keyCode;
        const charStr = String.fromCharCode(charCode);
        this.lastInput = charStr;
        let { onEnter = null } = this.props;
        if (onEnter !== null && e.key === 'Enter') {
            onEnter(e);
        }
    }
    onChange(e) {
        const { onChange } = this.props;
        const { value } = e.target;
        const formattedValue = this.format(value);

        // SET_STATE
        if (onChange) {
            e.target.value = formattedValue;
            onChange(e, formattedValue);
        }
    }
    onFocus(e) {
        const { onFocus, readOnly } = this.props;
        if (readOnly) return;

        if (onFocus) {
            onFocus(e);
        }

        this.setState({
            isFocused: true,
        });
    }
    onBlur(e) {
        // const { hasError } = this.state;
        const { onBlur } = this.props;

        if (onBlur) {
            onBlur(e);
        }

        this.setState({
            isFocused: false,
            // displayError: hasError
        });
    }
    onTooltipMouseOver = (e) => {
        this.setState({
            showTooltip: true,
        });
    };
    onTooltipMouseOut = (e) => {
        this.setState({
            showTooltip: false,
        });
    };
    // render
    renderError() {
        const { alertMessage, forceDisplayError } = this.props;
        const { displayError } = this.state;
        if (!displayError && !forceDisplayError) return null;
        return (
            <span className='field__alert' style={{ display: 'block' }}>{alertMessage}</span>
        );
    }
    renderAnimatedLabel() {
        const { animatedLabel, required } = this.props;
        if (!animatedLabel) return null;

        return (
            animatedLabel + (typeof required != 'undefined' && required ? ' *' : '')
        );
    }
    renderLabel() {
        const { label, required } = this.props;
        if (!label) return null;

        return (
            <span className='field__text'>
                {label + (typeof required != 'undefined' && required ? ' *' : '')}
            </span>
        );
    }
    renderValue() {
        const { label } = this.props;
        if (!label) return null;
        return <span className='field__value'>{label}</span>;
    }
    renderAutoresize() {
        const { value, placeholder, autoResize } = this.props;
        if (!autoResize) return null;
        return (
            <div className='field__input field__input--autoresize'>
                {value !== '' ? value : placeholder}
            </div>
        );
    }
    renderTooltip() {
        const { showTooltip } = this.state;
        const { tooltip } = this.props;

        if (!tooltip) {
            return '';
        }

        return (
            <StyledTooltipWrapper>
                <Tooltip placement='top' trigger='hover' tooltip={tooltip}>
                    <div className='field-tooltip'>?</div>
                </Tooltip>
            </StyledTooltipWrapper>
        );
    }
    renderLoading() {
        const { isLoading } = this.props;
        if (!isLoading) return null;
        return (
            <ReactLoading
                type='spin'
                color='black'
                height={20}
                width={20}
                className='button__spinner'
            />
        );
    }
    render() {
        return (
            <div
                className={this.handleClasses()}
                data-label={this.renderAnimatedLabel()}
                style={this.handleStyle()}
                ref={(r) => (this.field = r)}
            >
                {this.renderTooltip()}
                {this.renderLabel()}
                {this.renderAutoresize()}
                <input
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...this.generateProps()}
                    type='text'
                />
                {this.renderError()}
                {this.renderLoading()}
            </div>
        );
    }
}

// default props
Field.defaultProps = {
    label: undefined,
    animatedLabel: undefined,
    autoComplete: 'on',
    autoFocus: false,
    // type: 'text',
    name: 'field',
    value: '',
    placeholder: undefined,
    identical: undefined,
    step: 1,
    min: undefined,
    max: undefined,
    big: false,
    required: false,
    checked: undefined,
    readOnly: false,
    disabled: false,
    autoResize: false,
    alertMessage: 'This field is required.',
    showPercentageSign: false,
    // onChange: () => {},
};
// validate props
Field.propTypes = {
    // label: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    animatedLabel: PropTypes.string,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    // type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    placeholder: PropTypes.string,
    identical: PropTypes.any,
    step: PropTypes.number,
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    max: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    big: PropTypes.bool,
    required: PropTypes.bool,
    checked: PropTypes.bool,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    autoResize: PropTypes.bool,
    alertMessage: PropTypes.string,
    showPercentageSign: PropTypes.bool,
    // onChange: PropTypes.func.isRequired,
};

export default Field;
